<template>
  <div class="login-container">
    <div class="nav">
      <div class="logo-container">
        <img src="@/assets/mobile/top.png" alt="Logo" class="logo-image" />
      </div>

      <div class="time-container">
        <div class="time">{{ currentTime }}</div>
        <div class="lunar-date">{{ lunarDate }}</div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="login-box">
        <div class="login-header">
          <h1>注册账户</h1>
          <p>解读命理，揭秘未来</p>
        </div>

        <div class="login-form">
          <div class="form-item" style="background: transparent">
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid #caa87c;
                padding: 0 15px;
              "
            >
              <input
                class="email"
                v-model="registerForm.email"
                placeholder="请输入邮箱"
              />
              <div
                style="
                  white-space: nowrap;
                  text-align: center;
                  display: flex;
                  flex: 1;
                "
              >
                <span
                  class="send-code-button"
                  :disabled="codeCountdown > 0"
                  @click="sendVerificationCode"
                >
                  {{ codeCountdown > 0 ? codeCountdown + "S" : "获取验证码" }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.code"
              placeholder="邮箱验证码"
              maxlength="6"
            ></el-input>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.password"
              type="password"
              placeholder="邀请码"
            ></el-input>
          </div>
          <!-- <div class="form-item">
            <el-input
              v-model="registerForm.username"
              placeholder="显示名称"
            ></el-input>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.username"
              placeholder="密码"
            ></el-input>
          </div> -->
          <div class="form-item">
            <button class="login-button" @click="handleRegister">
              注册账户
            </button>
          </div>
          <div class="form-label" @click="goToLogin">
            <span>返回登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import solarLunar from "solarlunar";
import { login, sendCode } from "@/api/index";
export default {
  name: "mobile_register",
  data() {
    return {
      registerForm: {
        username: "",
        password: "",
        email: "",
        code: "",
      },
      currentTime: "",
      lunarDate: "",
      timer: null,
      codeTimer: null,
      codeCountdown: 0,
    };
  },
  created() {
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
    }
  },
  methods: {
    handleRegister() {
      if (!this.registerForm.email) {
        this.$message.error("请输入邮箱");
        return;
      }
      if (!this.registerForm.code) {
        this.$message.error("请输入验证码");
        return;
      }
      // if (!this.registerForm.password) {
      //   this.$message.error("请输入密码");
      //   return;
      // }
      // if (!this.registerForm.username) {
      //   this.$message.error("请输入用户名");
      //   return;
      // }
      login(this.registerForm)
        .then((response) => {
          console.log(response,'resooooooo');
          if (response.code === 200) {
            localStorage.setItem("ACCESS_TOKEN", response.data.auth);
            localStorage.setItem("userName", this.registerForm.email);
            this.$message.success("注册成功");
            this.$router.push({ path: "/mobile_home" });
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error(error.message || "注册失败");
        });
      // 实际项目中这里会调用API进行注册验证
    },
    updateTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      this.currentTime = `${hours}: ${minutes}: ${seconds}`;

      // 获取农历日期
      const solar = new Date();
      const lunarDate = solarLunar.solar2lunar(
        solar.getFullYear(),
        solar.getMonth() + 1,
        solar.getDate()
      );
      this.lunarDate = `${lunarDate.gzYear}年 ${lunarDate.gzMonth}月 ${lunarDate.gzDay}日`;
    },
    goToLogin() {
      this.$router.push({ path: "/mobile_login" });
    },
    getRandomStyle() {
      const size = Math.floor(Math.random() * 10) + 5;
      const posX = Math.random() * 100;
      const posY = Math.random() * 100;
      const animDuration = Math.random() * 20 + 10;
      const animDelay = Math.random() * 5;

      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${posX}%`,
        top: `${posY}%`,
        animationDuration: `${animDuration}s`,
        animationDelay: `${animDelay}s`,
      };
    },
    sendVerificationCode() {
      if (!this.registerForm.email) {
        this.$message.error("请输入邮箱");
        return;
      }
      if (this.codeCountdown > 0) return;
      this.codeCountdown = 60;
      this.codeTimer = setInterval(() => {
        if (this.codeCountdown > 0) {
          this.codeCountdown--;
        } else {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
        }
      }, 1000);
      sendCode({email:this.registerForm.email})
        .then((response) => {
          if (response.code === 200) {
            this.$message.success("验证码已发送");
          } else {
            this.$message.error(response.data.message || "发送失败");
          }
        })
        
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.login-container {
  height: 100%;
  width: 100%;
  position: relative;
  background: #0e1313;
  overflow: hidden;
  background-image: url("../../assets/back.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.content-wrapper {
  max-width: 1200px;
  margin: 60px auto 0 auto;
  padding: 0 20px;
  display: flex;
}

.planet-section {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 3rem; */
  max-width: 360px;
}

.planet-orbit {
  width: 300px;
  height: 300px;
  opacity: 0.8;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* transform-style: preserve-3d; */
  /* perspective: 1000px; */
  /* transform: rotateX(20deg); */
}

.planet-text {
  /* margin-top: 30px; */
  color: #ffe8ca;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    margin-bottom: 10px;
    letter-spacing: 2px;
    animation: fadeInUp 0.8s ease-out forwards;
  }

  p {
    font-size: 16px;
    opacity: 0.8;
    font-family: Kunminghaiouti, Kunminghaiouti;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.logo-container {
  z-index: 10;
}

.logo-image {
  height: 30px;
  width: 150px;
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Source Han Serif SC, Source Han Serif SC;
  font-weight: 400;
  font-size: 12px;
  color: #caa87c;
  padding: 0 20px;
  text-align: right;
  height: 56px;
}
.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.circle-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 0, 0, 0.05);
  box-shadow: 0 0 50px rgba(255, 0, 0, 0.1);
}

.circle-1 {
  width: 600px;
  height: 600px;
  top: -200px;
  right: -200px;
  background: rgba(255, 0, 0, 0.03);
  animation: float 20s infinite ease-in-out;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -100px;
  left: -100px;
  background: rgba(255, 0, 0, 0.04);
  animation: float 15s infinite ease-in-out reverse;
}

.circle-3 {
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 0, 0, 0.02);
  animation: pulse 10s infinite ease-in-out;
}

.particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float-particle 20s infinite linear;
}

.login-box {
  position: relative;
  z-index: 1;
  width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;

  h1 {
    color: #ffe8ca;
    font-size: 28px;
    margin-bottom: 10px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    letter-spacing: 2px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    animation: fadeInUp 0.8s ease-out forwards;
  }

  p {
    color: #ffe8ca;
    font-size: 20px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.login-form {
  .form-item {
    margin-bottom: 20px;
    background: transparent;
    border: none;
    padding: 0 20px;
  }

  .form-label {
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    letter-spacing: 1px;
    text-align: center;
    cursor: pointer;
  }

  ::v-deep .el-input__inner {
    background: transparent;
    border: 1px solid #caa87c;
    color: #fff;
    height: 50px;
    border-radius: 4px;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    position: relative;
    transition: all 0.3s ease;
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  ::v-deep .el-input {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      border-radius: 4px;
      z-index: 1;
      background: linear-gradient(90deg, #caa87c, #ffe8ca, #caa87c);
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      padding: 1px;
      background-size: 200% 100%;
      background-position: 0% 0%;
      animation: borderFlow 3s infinite linear;
      opacity: 0.8;
    }

    &:focus-within::before {
      opacity: 1;
      animation: borderFlow 1.5s infinite linear;
      background: linear-gradient(90deg, #ffe8ca, #caa87c, #ffe8ca, #caa87c);
      background-size: 300% 100%;
      box-shadow: 0 0 10px rgba(202, 168, 124, 0.5);
    }
  }

  ::v-deep .el-input__prefix {
    display: none;
  }
  .email {
    background: transparent;
    border: none;
    height: 50px;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    outline: none;
  }
  .send-code-button {
    height: 100%;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    margin-left: 10px;
    white-space: nowrap;
    width: 100%;
    text-align: center;
  }
  .login-button {
    width: 100%;
    height: 44px;
    background: #caa87c !important;
    border: 1px solid #caa87c;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #161b1a;
    letter-spacing: 2px;
    border-radius: 22px;
    border-color: none;
    &:hover,
    &:focus {
      background: #d6b88c;
    }
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-30px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
}

@keyframes float-particle {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) rotate(360deg);
    opacity: 0;
  }
}

@keyframes borderFlow {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 200% 0%;
  }
}
</style>